import { CheckCircleIcon, CheckIcon } from '@chakra-ui/icons';
import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

interface FormStatusFeedbackProps {
  type: 'success' | 'error';
  children: React.ReactNode;
}

const FormStatusFeedback: React.FC<FormStatusFeedbackProps> = ({
  type,
  children,
}) => {
  const Styles = useMultiStyleConfig('FormStatusFeedback', { type });
  return (
    <Box __css={Styles.container}>
      {children}
      {type === 'success' && (
        <Box __css={Styles.indicator}>
          <CheckIcon color="wl-blue.royal" />
        </Box>
      )}
    </Box>
  );
};

export default FormStatusFeedback;
